/* 
 * Handle Weather service on page load
*
*/

// Get Cookie
function getCookie(c_name) {
	var c_value = document.cookie;
	var c_start = c_value.indexOf(" " + c_name + "=");
	if (c_start == -1) {
		c_start = c_value.indexOf(c_name + "=");
	}
	if (c_start == -1) {
		c_value = null;
	} else {
		c_start = c_value.indexOf("=", c_start) + 1;
		var c_end = c_value.indexOf(";", c_start);
		if (c_end == -1) {
		c_end = c_value.length;
		}
		c_value = unescape(c_value.substring(c_start, c_end));
	}
	return c_value;
}

// Set Cookie
function createCookie(name,value,minutes) {
    if (minutes) {
        var date = new Date();
        date.setTime(date.getTime()+(minutes*60*1000));
        var expires = "; expires="+date.toGMTString();
    } else {
        var expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/; SameSite=None; Secure";
}

// Async Weather function
async function loadWeather() {
	const weatherContainer = document.getElementById("weather-api-container");
	const latitude = weatherContainer.getAttribute("data-lat");
	const longitude = weatherContainer.getAttribute("data-long");
	const units = weatherContainer.getAttribute("data-unit");
	const randomid = weatherContainer.getAttribute("data-randomid");
	const bothTemp = weatherContainer.getAttribute("data-show-both");
	
	// Api
	const apiKey = 'fd4600fb6dc1966243a1d743dacc22b0';	
	const response = await fetch( 'https://api.openweathermap.org/data/2.5/forecast?lat=' + latitude + '&lon=' + longitude + '&appid=' + apiKey + '&limit=1&units=' + units );
	const res = await response.json();
	if ( res.cod !== '400' ) {
		// custom vars
		let unit = '';		
		const weatherIcon = 'https://s3-us-west-2.amazonaws.com/s.cdpn.io/162656/' + res.list[ 0 ].weather[ 0 ].icon + '.svg';				
		const weatherTemp = Math.round( res.list[ 0 ].main.temp ) + unit;		
		//const cookieMinutes = 1; // 1 minute - testing only
		const cookieMinutes = 1 * 60; // 1 hours
		let calculatedTemp  = weatherTemp;
		
		if ( units === 'metric' ) { unit = '°C'; } else { unit = '°F'; }

		// Both Temperatures?
		if(bothTemp == 'true') {
			if ( units === 'metric' ) {
				// console.log('-- C to F --');
				let cToFahr = Math.round( res.list[ 0 ].main.temp ) * 9 / 5 + 32;
				calculatedTemp = Math.round( res.list[ 0 ].main.temp )+'\xB0C | ' + Math.round(cToFahr) + '\xB0F';				
				document.getElementById("weather-api-temp").innerHTML = calculatedTemp;
			} else { 
				// console.log('-- F to C --');
				let fToCel = ( res.list[ 0 ].main.temp - 32) * 5 / 9;
				calculatedTemp = Math.round( res.list[ 0 ].main.temp )+'\xB0F | ' +  Math.round(fToCel) + '\xB0C';				
				document.getElementById("weather-api-temp").innerHTML = calculatedTemp;
			}
		}else{
			// console.log('-- Do not show both --');
			document.getElementById("weather-api-temp").innerHTML = weatherTemp;
		}
		
		// console.log('Calculated Temp: ' + calculatedTemp);

		// Create the cookie to avoid multiple Api calls on page refresh					
		createCookie('weather-temp', calculatedTemp, cookieMinutes);
		createCookie('weather-updated', true, cookieMinutes); 		
		createCookie('weather-icon', weatherIcon, cookieMinutes);
		createCookie('weather-changed', randomid, cookieMinutes);

		// console.log("Api - Temp - cookie: " + getCookie( 'weather-temp' ));

		// Temperature setup
		document.getElementById("weather-api-icon").style.visibility = 'visible';
		document.getElementById("weather-api-icon").src = weatherIcon;
		console.log('completed');
	} else {
		// if Lat and Long are invalid, hide the Icon and show -- for temperature
		console.log( 'Can not show weather. Check your Latitude and Longitude values.' );
		document.getElementById("weather-api-icon").style.visibility = 'hidden';
		document.getElementById("weather-api-temp").innerHTML = '--';
	}
}

// On load, trigger the weather update
window.onload = function() {
	// console.log( 'On Load - T - cookie: ' + getCookie( 'weather-temp' ));	
	if( getCookie( 'weather-updated' ) != null) {
		// check if the ID from the database changed. If so, call the Api, other wise use cookie values.
		if(document.getElementById("weather-api-container").getAttribute("data-randomid") != getCookie( 'weather-changed' )) {
			console.log('RandomID cookie is different from DB. Call the Api.');
			loadWeather();
		} else {
			console.log('RandomID matches the DB. use the Cookie value.');
			document.getElementById("weather-api-icon").src = getCookie( 'weather-icon' );
			document.getElementById("weather-api-temp").innerHTML = getCookie( 'weather-temp' );
		}		
	}else{
		console.log('Weather-Updated flag does not exists. Calling the Api...');
		loadWeather();
	}	
};
